import React, { createContext, useState, useContext } from 'react';

// Create the Context
export const DrawerContext = createContext();

// Create a Provider component
export const DrawerProvider = ({ children }) => {
  const [admissionDetailsDrawerOpen, setAdmissionDetailsDrawerOpen] = useState(false);
  const [component, setComponent] = useState(null);
  const [chatId, setChatId] = useState(null);
  const [sidebarData, setSideBarData] = useState(null);

  const toggleAdmissionDetailsDrawer = (open, id, component, data) => (event) => {
    console.log('toggleAdmissionDetailsDrawer called with:', open, id, event);
    setChatId(id);
    setComponent(component);
    setSideBarData(data);
    // console.log('toggleAdmissionDetailsDrawer called with:', open, event);
    // This handles keyboard events to prevent closing the drawer unexpectedly
    // when tabbing through focusable elements inside.
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setAdmissionDetailsDrawerOpen(open);
  };

  // The value that will be provided to consumers of this context
  const contextValue = {
    admissionDetailsDrawerOpen,
    toggleAdmissionDetailsDrawer,
    setComponent,
    component,
    chatId,
    setChatId,
    sidebarData
  };

  return (
    <DrawerContext.Provider value={contextValue}>
      {children}
    </DrawerContext.Provider>
  );
};

// Custom hook to easily consume the context
export const useDrawer = () => {
  return useContext(DrawerContext);
};